import React from 'react';
import { useTranslation } from 'react-i18next';
import PanelDatosContacto from './panel-datos-contacto';

const DatosContacto = (props) => {
  const { t } = useTranslation('translations');
  return (

    <div>
      <h3 className='text-2xl font-color-mbr-color-primario mb-2'>{t('checkout.contact')}</h3>
      <div className='clearfix' />
      <PanelDatosContacto actualizarCheckbox={props.actualizarCheckbox} actualizarDatosContacto={props.actualizarDatosContacto} />
    </div>
  );
};
export default DatosContacto;
